import PropTypes from 'prop-types';

export const AVAILABILITY = PropTypes.shape({
  hash: PropTypes.string,
  description: PropTypes.string.isRequired,
});

export const CANDIDATE_ROLE = PropTypes.shape({
  hash: PropTypes.string,
  name: PropTypes.string.isRequired,
});

export const PERIOD_OBJECT = {
  hash: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export const PERIOD_SHAPE = PropTypes.shape(PERIOD_OBJECT);

export const SKILL_OBJECT = {
  hash: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
};

export const SKILL_SHAPE = PropTypes.shape(SKILL_OBJECT);
export const SKILL_LIST = PropTypes.arrayOf(SKILL_SHAPE);

export const CANDIDATE = PropTypes.shape({
  firstName: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  role: CANDIDATE_ROLE.isRequired,
  availability: AVAILABILITY.isRequired,
  online: PropTypes.string,
  github: PropTypes.string,
  video: PropTypes.string,
});

export const CERTIFICATION = PropTypes.shape({
  hash: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  institution: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
});

export const CERTIFICATION_LIST = PropTypes.arrayOf(CERTIFICATION);

export const DEGREE = PropTypes.shape({
  hash: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  university: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
});

export const DEGREE_LIST = PropTypes.arrayOf(DEGREE);

export const DETAIL = PropTypes.shape({
  icon: PropTypes.element,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  detail: PropTypes.element,
});

export const EXPERIENCE = PropTypes.shape({
  hash: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  since: PropTypes.string.isRequired,
  until: PropTypes.string.isRequired,
});

export const FOOTER = PropTypes.shape({
  withInterview: PropTypes.bool,
});

export const FOOTER_ITEM = PropTypes.shape({
  icon: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
});

export const FORM = PropTypes.shape({
  disabled: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
});

export const INPUT = PropTypes.shape({
  className: PropTypes.string,
  startIcon: PropTypes.element,
  invalid: PropTypes.bool,
  message: PropTypes.string,
  textarea: PropTypes.bool,
  resize: PropTypes.oneOf([
    'none',
    'both',
    'horizontal',
    'vertical',
    'initial',
    'inherit',
  ]),
});

export const LIST = PropTypes.shape({
  title: PropTypes.string,
  list: PropTypes.array.isRequired,
  item: PropTypes.element.isRequired,
});

export const LOADER = PropTypes.shape({
  label: PropTypes.string,
  className: PropTypes.string,
});

export const MODAL = PropTypes.shape({
  open: PropTypes.bool.isRequired,
  className: PropTypes.string,
});

export const NOT_FOUNT_PAGE = PropTypes.shape({
  message: PropTypes.string,
});

export const NOTIFICATION = PropTypes.shape({
  id: PropTypes.any.isRequired,
  type: PropTypes.oneOf(['success', 'danger']).isRequired,
  message: PropTypes.string.isRequired,
  timeout: PropTypes.number,
  onClose: PropTypes.func.isRequired,
});

export const PROJECT = PropTypes.shape({
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  link: PropTypes.string,
  skills: SKILL_LIST.isRequired,
  append: PropTypes.func,
  projectIdx: PropTypes.number,
  experienceHash: PropTypes.string,
});

export const QUOTE = PropTypes.shape({
  hash: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  comment: PropTypes.string.isRequired,
});

export const TAB_LINK = PropTypes.shape({
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
});
